'use client';

import React, { useState, useEffect } from 'react';




const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState<number | null>(null);

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date()?.getFullYear());
  }, []);

  const footerLinks = {
    company: [
      { label: 'Case Studies', href: '/case-studies' },
      { label: 'Technology', href: '/technology-platform' },
    ],

    resources: [
    { label: 'Documentation', href: '/resources/docs' },
    { label: 'API Reference', href: '/resources/api' },
    { label: 'Blog', href: '/resources/blog' },
    { label: 'Support', href: '/support' }],

    legal: [
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Terms of Service', href: '/legal/terms' },
    { label: 'Security', href: '/legal/security' },
    { label: 'Compliance', href: '/legal/compliance' }]

  };

  const socialLinks = [
  { name: 'Twitter', icon: 'AtSymbolIcon', href: '#' },
  { name: 'LinkedIn', icon: 'BuildingOfficeIcon', href: '#' },
  { name: 'GitHub', icon: 'CodeBracketIcon', href: '#' },
  { name: 'YouTube', icon: 'PlayCircleIcon', href: '#' }];


  return (
    <footer data-component-id="src/app/homepage/components/Footer.tsx:45:4" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="45" data-component-end-line="159" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%2C%22className%22%3A%22bg-brand-slate%20text-primary-foreground%22%7D" className="bg-brand-slate text-primary-foreground">
      <div data-component-id="src/app/homepage/components/Footer.tsx:46:6" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="46" data-component-end-line="158" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-2%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div data-component-id="src/app/homepage/components/Footer.tsx:47:8" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="47" data-component-end-line="134" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-2%20lg%3Agrid-cols-6%20gap-4%20mb-3%22%7D" className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-3">
          {/* Brand Section */}
          <div data-component-id="src/app/homepage/components/Footer.tsx:49:10" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="49" data-component-end-line="65" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%22%7D" className="lg:col-span-2">
            <p data-component-id="src/app/homepage/components/Footer.tsx:50:12" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="50" data-component-end-line="52" data-component-file="Footer.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-primary-foreground%2F70%20mb-2%20max-w-sm%20text-sm%22%2C%22textContent%22%3A%22Enterprise-grade%20voice%20AI%20solutions%20that%20transform%20customer%20experiences%20and%20drive%20business%20growth.%22%7D" className="text-primary-foreground/70 mb-2 max-w-sm text-sm">
              Enterprise-grade voice AI solutions that transform customer experiences and drive business growth.
            </p>
            











          </div>

          {/* Solutions */}
          















          {/* Company */}
          















          {/* Resources */}
          















          {/* Legal */}
          














        </div>

        {/* Bottom Bar */}
        <div data-component-id="src/app/homepage/components/Footer.tsx:137:8" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="137" data-component-end-line="157" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pt-2%20border-t%20border-primary-foreground%2F20%22%7D" className="pt-2 border-t border-primary-foreground/20">
          <div data-component-id="src/app/homepage/components/Footer.tsx:138:10" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="138" data-component-end-line="156" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20md%3Aflex-row%20justify-between%20items-center%20space-y-2%20md%3Aspace-y-0%22%7D" className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p data-component-id="src/app/homepage/components/Footer.tsx:139:12" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="139" data-component-end-line="141" data-component-file="Footer.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-primary-foreground%2F70%22%2C%22textContent%22%3A%22AELY%20AI.%20All%20rights%20reserved.%22%7D" className="text-sm text-primary-foreground/70">
              {isHydrated && currentYear ? `© ${currentYear}` : '© 2025'} AELY AI. All rights reserved.
            </p>
            <div data-component-id="src/app/homepage/components/Footer.tsx:142:12" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="142" data-component-end-line="155" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-4%22%7D" className="flex items-center space-x-4">
              <div data-component-id="src/app/homepage/components/Footer.tsx:143:14" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="143" data-component-end-line="146" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%22%7D" className="flex items-center space-x-2">
                
                
              </div>
              <div data-component-id="src/app/homepage/components/Footer.tsx:147:14" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="147" data-component-end-line="150" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%22%7D" className="flex items-center space-x-2">
                
                
              </div>
              <div data-component-id="src/app/homepage/components/Footer.tsx:151:14" data-component-path="src/app/homepage/components/Footer.tsx" data-component-line="151" data-component-end-line="154" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%22%7D" className="flex items-center space-x-2">
                
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;